
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embed/create/tour",
      function () {
        return require("private-next-pages/embed/create/tour.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embed/create/tour"])
      });
    }
  